import { Response } from '@ciaopeople/cp-shatsu/HTTP';
import { isFunction, isObject } from "@ciaopeople/cp-shatsu/TypeChecking";
import { BookmarkCheckRequest, BookmarkCheckResponse, BookmarkedContentsResponse, BookmarkQueryObj } from "./types/BookmarkingDataTypes.js";
import { MembershipStatusInfo } from './types/MembershipStatusInfo.js';
import { FollowResponseObject, GroupedResolvedTopicObjs, RecommendedCount, RecommendedResponse, TopicFollowCheckRequest, TopicFollowCheckResponse, TopicObj, TopicQueryObj, TopicSubscriptionCheckRequest, TopicSubscriptionCheckResponse, UserActionExtraInfo } from "./types/NotificationDataTypes.js";
import { DeviceOrientedRequest, DeviceUpdateRequestPayload, SubscriptionListResponse } from "./types/SubscriptionTypes.js";
import { Ask1stPartyEmailAuthData, OnLoginResponse, OnUserUpdateData, UserFullInfo } from "./types/UserDataTypes.js";
import { Ask1stPartyEmailLoginOperation } from './APIClientInterface.js';
import { OTPVerificationResponse } from '@api-commons/sdk/ClientSdkPublicInterface.js';

export interface EmailLoginAskResponse {

    result: boolean,
    purpose?: Ask1stPartyEmailLoginOperation,
    challenge: string

}



export type FullContent = any;

export interface RESTUserServices {
    
    follow(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<FollowResponseObject>>
    unfollow(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<FollowResponseObject>>
    checkFollowedTopics(checkReq: TopicFollowCheckRequest): Promise<Response<TopicFollowCheckResponse>>
    getUserFollowedTopics(): Promise<Response<GroupedResolvedTopicObjs>>
    getRecommended(skip: number, limit: number): Promise<Response<RecommendedResponse>>
    getRecommendedCount(): Promise<Response<RecommendedCount>>


    subscribeNewsletter(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<TopicObj>>
    unsubscribeNewsletter(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<TopicObj>>
    removeNewsletter(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<TopicObj>>
    listNewsletterSubscriptions(): Promise<Response<TopicObj[]>>

    checkNewsletterSubscriptions(checkReq: TopicSubscriptionCheckRequest): Promise<Response<TopicSubscriptionCheckResponse>>

    
    registerDevice(deviceReq: DeviceUpdateRequestPayload): Promise<Response<SubscriptionListResponse>>
    unregisterDevice(deviceReq: DeviceOrientedRequest): Promise<Response<SubscriptionListResponse>>
    enableDevice(deviceReq: DeviceOrientedRequest): Promise<Response<SubscriptionListResponse>>
    disableDevice(deviceReq: DeviceOrientedRequest): Promise<Response<SubscriptionListResponse>>
    listDevices(): Promise<Response<SubscriptionListResponse>>

    checkSavedArticles(checkReq: BookmarkCheckRequest): Promise<Response<BookmarkCheckResponse>>
    bookmark(q: BookmarkQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<BookmarkCheckResponse>>
    unbookmark(q: BookmarkQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<BookmarkCheckResponse>>
    getSavedArticles(): Promise<Response<BookmarkedContentsResponse>>

    getMyPage(): Promise<Response<any>>
    getMyMenu(): Promise<Response<any>>
    getSlider(sliderName: string, href?: string): Promise<Response<any>>
    resolve(url: string): Promise<Response<FullContent>>
    apiFreeCall(url: string): Promise<Response<any>>
    /**
     * @warn Il parametro full_data è stato deprecato, ora le risposte sono sempre del tipo full
     * @param full_data 
     */
    getMe(full_data: boolean): Promise<Response<UserFullInfo>>

    updatePersonalData(upd: OnUserUpdateData): Promise<Response<OnLoginResponse>>;

    becomeMember(): Promise<Response<any>>;
    memberInfo(): Promise<Response<any>>;

    getMembershipStatusInfo(): Promise<MembershipStatusInfo>;

    ask1stPartyEmailLogin(operation: Ask1stPartyEmailLoginOperation, data: Ask1stPartyEmailAuthData): Promise<EmailLoginAskResponse>;
    verificationWithOTPCode(challenge: string, code: string): Promise<OTPVerificationResponse>;

    getEventPlatformToken(): Promise<string>
}

export function isRESTUserServices(obj: any): obj is RESTUserServices {
    return isObject(obj) &&
            isFunction(obj.follow) &&
            isFunction(obj.unfollow) &&
            isFunction(obj.checkFollowedTopics) &&
            isFunction(obj.getUserFollowedTopics) &&
            isFunction(obj.getRecommended) &&
            isFunction(obj.getRecommendedCount) &&
            isFunction(obj.registerDevice) &&
            isFunction(obj.unregisterDevice) &&
            isFunction(obj.checkSavedArticles) &&
            isFunction(obj.getMyPage) &&
            isFunction(obj.getMe) &&
            isFunction(obj.checkNewsletterSubscriptions) &&
            isFunction(obj.subscribeNewsletter) &&
            isFunction(obj.unsubscribeNewsletter) &&
            isFunction(obj.removeNewsletter) &&
            isFunction(obj.listNewsletterSubscriptions) &&
            isFunction(obj.getMyMenu) && 
            isFunction(obj.getEventPlatformToken)&& 
            isFunction(obj.ask1stPartyEmailLogin) &&
            isFunction(obj.verificationWithOTPCode);
}


export type RESTUserServicesMethod = keyof RESTUserServices;


export const AllRESTUserServicesMethods: RESTUserServicesMethod[] = [
    "follow",
    "unfollow",
    "bookmark",
    "unbookmark",
    "checkFollowedTopics",
    "getUserFollowedTopics",
    "getRecommended",
    "getRecommendedCount",
    "registerDevice",
    "unregisterDevice",
    "checkSavedArticles",
    "getSavedArticles",
    "getMyPage",
    "getMyMenu",
    "getSlider",
    "resolve",
    "apiFreeCall",
    "getMe",
    "becomeMember",
    "memberInfo",
    "checkNewsletterSubscriptions",
    "subscribeNewsletter",
    "unsubscribeNewsletter",
    "removeNewsletter",
    "listNewsletterSubscriptions",
    "registerDevice",
    "unregisterDevice",
    "enableDevice",
    "disableDevice",
    "listDevices",
    "ask1stPartyEmailLogin",
    "getEventPlatformToken",
    "verificationWithOTPCode"

];